var esCookie = {};

export { esCookie as __exports };
//# sourceMappingURL=_virtual-es-cookie.js.map
